<!-- AB#22077 — the outcome and source of an entry as pills. -->
<template>
  <span class="aop">
    <span
      class="aop-pill"
      :class="`aop-${entry.outcome}`"
      :data-test="`audit-outcome-${entry.outcome}`"
    >
      {{ outcomeLabel(entry.outcome) }}
    </span>
    <span v-if="entry.source !== 'portal'" class="aop-pill" :class="`aop-src-${entry.source}`">
      {{ sourceLabel(entry.source) }}
    </span>
  </span>
</template>

<script setup lang="ts">
import { outcomeLabel, sourceLabel, type AuditEntry } from '@/composables/useAuditLog';

defineProps<{ entry: Pick<AuditEntry, 'outcome' | 'source'> }>();
</script>

<style scoped>
.aop {
  display: inline-flex;
  gap: 4px;
  flex-wrap: wrap;
}
.aop-pill {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  padding: 2px 8px;
  line-height: 1.4;
  white-space: nowrap;
}
.aop-allowed {
  background: color-mix(in srgb, var(--success) 14%, transparent);
  color: var(--success);
}
.aop-refused,
.aop-failed {
  background: color-mix(in srgb, var(--danger) 14%, transparent);
  color: var(--danger);
}
.aop-src-impersonation {
  background: color-mix(in srgb, var(--warning) 16%, transparent);
  color: var(--warning);
}
.aop-src-system {
  background: var(--surface-3, var(--surface-2));
  color: var(--ink-soft);
}
.aop-src-api {
  background: var(--accent-soft);
  color: var(--accent);
}
</style>
